export interface CaregiverFormData {
  // Basic Info (Step 1)
  type: string;
  firstName: string;
  middleName: string;
  lastName: string;
  otherLastName: string;
  dateOfBirth: string;
  email: string;
  phone: string;
  gender: string;
  countyName: string;
  primaryLanguage: string;
  additionalLanguages: string;
  howDidYouHearAboutUs: string;
  street: string;
  aptUnitNumber: string;
  city: string;
  state: string;
  zipCode: string;
  physicalAddressDifferentThanMailing: boolean;
  otherAddressLine1: string;
  otherCity: string;
  otherState: string;
  otherZipCode: string;
  otherAptUnitNumber: string;

  // Human Resources (Step 2)
  ssn: string;
  homecareExperienceYears: string;
  taxClassification: string;
  citizenStatus: string;
  uscisNumber: string;
  noncitizenDocumentType: string;
  noncitizenExpirationDate: string;
  formI94AdmissionNumber: string;
  foreignPassportNumber: string;
  foreignPassportCountry: string;
  federalFilingStatus: string;
  dependentsUnderAge17: string;
  fedDeductions: string;
  otherDependents: string;
  fedAdditionalWithholdingAmount: string;
  otherIncome: string;
  multipleJobs: boolean;

  // Emergency Contact & References (Step 3)
  professionalReferenceName: string;
  professionalReferenceRelationship: string;
  professionalReferencePhone: string;
  personalReferenceName: string;
  personalReferenceRelationship: string;
  personalReferencePhone: string;
  emergencyContactName: string;
  emergencyContactRelationship: string;
  emergencyContactPhone: string;

  // Availability & Preferences (Step 4)
  ableToDrive: string;
  hasACar: string;
  countyMiamiDade: boolean;
  countyBroward: boolean;
  countyPalmBeach: boolean;
  worksWithPets: string;
  worksWithSmokers: string;
  areasOfWorkMiamiDade: string;
  areasOfWorkBroward: string;
  areasOfWorkPalmBeach: string;

  // Medical (Step 5)
  hasReceivedFluVaccineThisSeason: string;
  fluVaccineDate: string;
  fluVaccineDecision: string;
  fluDeclinationReason: string;
  fluDeclinationOtherReason: string;
  hepBVaccinationDecision: string;
  hepBImmuneStatus: string;
  hepBInjection1: string;
  hepBInjection2: string;
  hepBInjection3: string;
  sysHepBDecision: string;
  tbSymptoms: string;
  exposedToTb: string;
  weaknessComment: string;
  immunosuppressionComment: string;
  lackOfAppetiteComment: string;
  residentOfTbCountryComment: string;
  lowGradeFeverComment: string;
  nightSweatsComment: string;
  flulikeSymptomsComment: string;
  chestPainsComment: string;
  shortnessOfBreathComment: string;
  persistentCoughComment: string;
  bloodTingedSputumComment: string;

  // Signature (Step 6)
  portalSignature: string;
  portalSignatureBlobKey: string;
  portalStatus: string;
  portalSignatureDate: string;
  contactPhotoUrl: string;
  contactPhotoBlobKey: string;
}

export const INITIAL_FORM_DATA: CaregiverFormData = {
  // Basic Info (Step 1)
  type: '',
  firstName: '',
  middleName: '',
  lastName: '',
  otherLastName: '',
  dateOfBirth: '',
  email: '',
  phone: '',
  gender: '',
  countyName: '',
  primaryLanguage: '',
  additionalLanguages: '',
  howDidYouHearAboutUs: '',
  street: '',
  aptUnitNumber: '',
  city: '',
  state: '',
  zipCode: '',
  physicalAddressDifferentThanMailing: false,
  otherAddressLine1: '',
  otherCity: '',
  otherState: '',
  otherZipCode: '',
  otherAptUnitNumber: '',

  // Human Resources (Step 2)
  ssn: '',
  homecareExperienceYears: '',
  taxClassification: '',
  citizenStatus: '',
  uscisNumber: '',
  noncitizenDocumentType: '',
  noncitizenExpirationDate: '',
  formI94AdmissionNumber: '',
  foreignPassportNumber: '',
  foreignPassportCountry: '',
  federalFilingStatus: '',
  dependentsUnderAge17: '',
  fedDeductions: '',
  otherDependents: '',
  fedAdditionalWithholdingAmount: '',
  otherIncome: '',
  multipleJobs: false,

  // Emergency Contact & References (Step 3)
  professionalReferenceName: '',
  professionalReferenceRelationship: '',
  professionalReferencePhone: '',
  personalReferenceName: '',
  personalReferenceRelationship: '',
  personalReferencePhone: '',
  emergencyContactName: '',
  emergencyContactRelationship: '',
  emergencyContactPhone: '',

  // Availability & Preferences (Step 4)
  ableToDrive: '',
  hasACar: '',
  countyMiamiDade: false,
  countyBroward: false,
  countyPalmBeach: false,
  worksWithPets: '',
  worksWithSmokers: '',
  areasOfWorkMiamiDade: '',
  areasOfWorkBroward: '',
  areasOfWorkPalmBeach: '',

  // Medical (Step 5)
  hasReceivedFluVaccineThisSeason: '',
  fluVaccineDate: '',
  fluVaccineDecision: '',
  fluDeclinationReason: '',
  fluDeclinationOtherReason: '',
  hepBVaccinationDecision: '',
  hepBImmuneStatus: '',
  hepBInjection1: '',
  hepBInjection2: '',
  hepBInjection3: '',
  sysHepBDecision: '',
  tbSymptoms: '',
  exposedToTb: '',
  weaknessComment: '',
  immunosuppressionComment: '',
  lackOfAppetiteComment: '',
  residentOfTbCountryComment: '',
  lowGradeFeverComment: '',
  nightSweatsComment: '',
  flulikeSymptomsComment: '',
  chestPainsComment: '',
  shortnessOfBreathComment: '',
  persistentCoughComment: '',
  bloodTingedSputumComment: '',

  // Signature (Step 6)
  portalSignature: '',
  portalSignatureBlobKey: '',
  portalStatus: '',
  portalSignatureDate: '',
  contactPhotoUrl: '',
  contactPhotoBlobKey: '',
};

export const STEP_LABELS = [
  'Demographics',
  'Human Resources',
  'References / Emergency Contact',
  'Availability / Preferences',
  'Medical',
  'Signature',
  'Submitted',
];

export const STEP_PORTAL_STATUS = [
  'Demographics',
  'Human Resources',
  'References / Emergency Contact',
  'Availability / Preferences',
  'Medical',
  'Signature',
  'Submitted',
];

// Statuses no longer produced by the portal, mapped to the step that replaced them
// so caregivers mid-application aren't sent back to the beginning. Keyed by Nexus
// API value, since retired statuses no longer resolve to a portal display label.
export const RETIRED_PORTAL_STATUS: Record<string, string> = {
  DIRECT_DEPOSIT: 'Signature',
};
